// This file is auto-generated during build process
// Do not edit manually - it will be overwritten

export interface MicroSRPConfig {
  VITE_CX_URL: string;
  VITE_CDN_URL: string;
  VITE_CDN_ID: string;
  VITE_INVENTORY_API: string;
  VITE_IMAGE_SERVICE_API: string;
  VITE_JAMS_BACKEND_URL: string;
  VITE_JAMS_FRONTEND_URL: string;
  VITE_MUST_ENDPOINT: string;
  NPM_TOKEN: string;
  COMPONENTS_BUCKET_NAME: string;
}

export const config: MicroSRPConfig = {
  VITE_CX_URL: 'https://microsrp.cx.qa.sodasoft.io',
  VITE_CDN_URL: 'https://d1uk0lzwvlv9i9.cloudfront.net',
  VITE_CDN_ID: 'E3R5CF6S70BJPT',
  VITE_INVENTORY_API: 'https://t62e4qir64.execute-api.us-west-2.amazonaws.com/dev',
  VITE_IMAGE_SERVICE_API: 'https://media-a5-jazel-tango.jazel-qa.com',
  VITE_JAMS_BACKEND_URL: 'https://u4mchhy7h3.execute-api.us-west-2.amazonaws.com/qa',
  VITE_JAMS_FRONTEND_URL: 'https://jams.admin.qa.sodasoft.io',
  VITE_MUST_ENDPOINT: 'https://za7ksuje0g.execute-api.us-east-1.amazonaws.com',
  NPM_TOKEN: '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',
  COMPONENTS_BUCKET_NAME: 'jazel-lightning-components-qa'
};

export default config;
